






































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeVente from '@/stores/modules/vente';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import Checked from '@/components/Checked.vue';
import {Stored} from "vue-stored-prop-decorator/index";
import storeUser from "@/stores/modules/user";
import {User} from "@/models";

@Component({
	components: {
		CrudList,
		TableHead,
		TableCell,
		Checked,
	}
})
export default class CrudVenteList extends Vue {
	
	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeUser) me!: User;
	
	private storeVente = storeVente;
}
